import React from "react";
import { Grid, Typography, Container, Box, Divider } from "@mui/material";
import Sidebar from "../components/Sidebar";
import Footer from "../components/Footer";
import { useSelector } from "react-redux";

const PrivacyPolicy = () => {
  const state = useSelector((state) => state);

  return (
    <div className="main">
      <Sidebar />

      <div
        className="anigrad"
        style={{
          paddingBottom: "50px",
        }}
      >
        <div
          style={{
            height: "50vh",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            width: "100vw",
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              width: "75vw",
              marginLeft: state.auth.isMobile ? "0px" : "0px",
            }}
          >
            <div
              style={{
                fontSize: state.auth.isMobile ? "50px" : "80px",
                color: "yellow",
                zIndex: 999,
                textAlign: state.auth.isMobile ? "center" : "left",
              }}
            >
              Privacy Policy
            </div>

            <div
              style={{
                borderBottom: "2px solid white",
                width: "100%",
                margin: "15px 0px 15px 0px",
              }}
            ></div>
            <div
              style={{
                fontSize: state.auth.isMobile ? "20px" : "3vh",
                color: "white",
                zIndex: 999,
              }}
            >
              How we protect and manage your information
            </div>
          </div>
        </div>
      </div>
      <div style={{ width: "100%", backgroundColor: "white" }}>
        <Container
          maxWidth="lg"
          sx={{
            py: 5,
            px: state.auth.isMobile ? 2 : 5,
            mb: 10,
            textAlign: "left",
          }}
        >
          <Box sx={{ mb: 4 }}>
            <Typography variant="body1" paragraph>
              <strong>Effective Date:</strong> 01 January 2025
            </Typography>
            <Typography variant="body1" paragraph>
              Riches Media Digital is committed to protecting your personal data
              and digital privacy. This Privacy Policy outlines how we collect,
              use, store, and manage the information you share with us through
              our website, communication channels, or direct project engagement.
              It applies to all users who visit our site, submit project
              inquiries, or engage our services in any form.
            </Typography>
            <Typography variant="body1" paragraph>
              If you do not agree with any part of this policy, you must refrain
              from using our website or submitting any personal information.
            </Typography>
          </Box>

          <Box sx={{ mb: 4 }}>
            <Typography
              variant="h6"
              component="h2"
              gutterBottom
              sx={{ fontWeight: "bold", color: "black" }}
            >
              1. Information We Collect
            </Typography>
            <Typography variant="body1" paragraph>
              We only collect information that is necessary to deliver digital
              marketing services, respond to project briefs, or maintain client
              relationships. The nature and scope of data depend on the type of
              engagement. Categories of data may include:
            </Typography>
            <ul>
              <li>
                <Typography variant="body1">
                  Identity details such as your name and company affiliation
                </Typography>
              </li>
              <li>
                <Typography variant="body1">
                  Contact details such as your phone number and email address
                </Typography>
              </li>
              <li>
                <Typography variant="body1">
                  Business context, such as service needs and marketing goals
                </Typography>
              </li>
              <li>
                <Typography variant="body1">
                  Technical data, including browser type and IP address
                </Typography>
              </li>
              <li>
                <Typography variant="body1">
                  Communication history such as inquiries or support
                  conversations
                </Typography>
              </li>
            </ul>
            <Typography variant="body1" paragraph>
              We do not store payment information on our servers. All payment
              processing is handled by third-party providers who follow secure
              and industry-compliant practices.
            </Typography>
          </Box>

          <Box sx={{ mb: 4 }}>
            <Typography
              variant="h6"
              component="h2"
              gutterBottom
              sx={{ fontWeight: "bold", color: "black" }}
            >
              2. How Your Information Is Used
            </Typography>
            <Typography variant="body1" paragraph>
              Your information is used only for project execution, service
              delivery, or communication relating to your business inquiry. This
              includes:
            </Typography>
            <ul>
              <li>
                <Typography variant="body1">
                  Providing consultations and sending proposals
                </Typography>
              </li>
              <li>
                <Typography variant="body1">
                  Delivering creative services or campaign assets
                </Typography>
              </li>
              <li>
                <Typography variant="body1">
                  Responding to technical issues or client queries
                </Typography>
              </li>
              <li>
                <Typography variant="body1">
                  Sharing reports and project updates
                </Typography>
              </li>
            </ul>
            <Typography variant="body1" paragraph>
              We do not send unsolicited promotional messages. Every email,
              report, or communication is based on active service conversations
              or direct business interest expressed by you.
            </Typography>
          </Box>

          <Box sx={{ mb: 4 }}>
            <Typography
              variant="h6"
              component="h2"
              gutterBottom
              sx={{ fontWeight: "bold", color: "black" }}
            >
              3. Data Sharing and Third-Party Access
            </Typography>
            <Typography variant="body1" paragraph>
              Riches Media Digital does not sell, trade, or lease your
              information to any other business. We only disclose your data
              under specific and controlled situations such as:
            </Typography>
            <ul>
              <li>
                <Typography variant="body1">
                  Platform-based campaign management using authorized
                  credentials
                </Typography>
              </li>
              <li>
                <Typography variant="body1">
                  Analytics tracking using verified tools required to optimize
                  campaigns
                </Typography>
              </li>
              <li>
                <Typography variant="body1">
                  For legal or compliance purposes, when we are formally
                  required to submit data
                </Typography>
              </li>
            </ul>
            <Typography variant="body1" paragraph>
              We do not allow unrestricted access to your data. If any
              third-party vendor needs access for a specific task, we assess
              their compliance history and limit their access strictly to the
              agreed-upon function.
            </Typography>
          </Box>

          <Box sx={{ mb: 4 }}>
            <Typography
              variant="h6"
              component="h2"
              gutterBottom
              sx={{ fontWeight: "bold", color: "black" }}
            >
              4. Data Retention and Disposal
            </Typography>
            <Typography variant="body1" paragraph>
              We retain your data only for the duration necessary to manage your
              project or comply with obligations defined in our agreement. Once
              the project concludes or the business relationship ends, we
              archive the data securely or delete it based on legal and
              operational needs.
            </Typography>
            <Typography variant="body1" paragraph>
              If you request permanent removal of your data, we will process
              your request with confirmation and remove records that are not
              required for compliance or audit purposes. We do not retain copies
              of deleted data for commercial use.
            </Typography>
          </Box>

          <Box sx={{ mb: 4 }}>
            <Typography
              variant="h6"
              component="h2"
              gutterBottom
              sx={{ fontWeight: "bold", color: "black" }}
            >
              5. Data Protection and Internal Controls
            </Typography>
            <Typography variant="body1" paragraph>
              Safeguarding your data is a serious responsibility. We use a
              combination of digital and procedural measures to protect your
              information. This includes restricted access to internal
              dashboards and encrypted communication tools.
            </Typography>
            <Typography variant="body1" paragraph>
              All client-related data is stored on secure systems with regular
              updates to reflect current security standards. Our internal team
              is trained to avoid misuse or casual disclosure of sensitive
              project or contact details. We also apply endpoint monitoring to
              prevent unauthorized transfers.
            </Typography>
          </Box>

          <Box sx={{ mb: 4 }}>
            <Typography
              variant="h6"
              component="h2"
              gutterBottom
              sx={{ fontWeight: "bold", color: "black" }}
            >
              6. Website Usage and Cookies
            </Typography>
            <Typography variant="body1" paragraph>
              Our website may use essential cookies to monitor how visitors
              interact with pages. These cookies help us understand which
              services are accessed, how long visitors stay on specific pages,
              and what referral sources brought them to our site.
            </Typography>
            <Typography variant="body1" paragraph>
              No cookie data is tied to personal identity or payment activity.
              You can choose to disable cookies using your browser settings.
              Some features of the website may not work correctly if cookies are
              blocked. We do not use third-party advertising cookies that track
              user behavior across external sites.
            </Typography>
          </Box>

          <Box sx={{ mb: 4 }}>
            <Typography
              variant="h6"
              component="h2"
              gutterBottom
              sx={{ fontWeight: "bold", color: "black" }}
            >
              7. Your Rights and Access Control
            </Typography>
            <Typography variant="body1" paragraph>
              You have the right to request access to any information we hold
              about you. If any data is outdated or inaccurate, you may request
              that it be corrected or removed. We will respond to such requests
              in accordance with local data protection regulations.
            </Typography>
            <Typography variant="body1" paragraph>
              You may also request a written record of how your data is being
              used and which services involve its access. If you wish to
              restrict our use of your information in part or in full, you must
              submit that request formally through the contact information at
              the end of this policy.
            </Typography>
          </Box>

          <Box sx={{ mb: 4 }}>
            <Typography
              variant="h6"
              component="h2"
              gutterBottom
              sx={{ fontWeight: "bold", color: "black" }}
            >
              8. International Data Handling
            </Typography>
            <Typography variant="body1" paragraph>
              Our core operations are based in India. However, certain tools or
              service integrations may involve data processing on servers
              located outside the country. In such cases, we select vendors who
              comply with international data security standards and who offer
              contractual guarantees about privacy controls.
            </Typography>
            <Typography variant="body1" paragraph>
              We do not engage any cloud-based platforms unless their compliance
              record is verifiable. All vendors are vetted for reliability and
              must agree to data handling restrictions aligned with client
              expectations.
            </Typography>
          </Box>

          <Box sx={{ mb: 4 }}>
            <Typography
              variant="h6"
              component="h2"
              gutterBottom
              sx={{ fontWeight: "bold", color: "black" }}
            >
              9. Legal Jurisdiction
            </Typography>
            <Typography variant="body1" paragraph>
              This policy is governed by the laws of the Republic of India. Any
              disputes or claims arising in relation to this document will be
              addressed under the appropriate jurisdiction of Indian courts.
            </Typography>
            <Typography variant="body1" paragraph>
              We comply with all applicable national data protection rules. Any
              changes to the legal framework governing data privacy will be
              reflected in our internal protocols and this public-facing
              document.
            </Typography>
          </Box>

          <Box sx={{ mb: 4 }}>
            <Typography
              variant="h6"
              component="h2"
              gutterBottom
              sx={{ fontWeight: "bold", color: "black" }}
            >
              10. Updates to the Privacy Policy
            </Typography>
            <Typography variant="body1" paragraph>
              We may revise this Privacy Policy as business practices evolve or
              as regulations change. Updates will be made available through this
              webpage. Where changes materially affect the scope of data
              collection or usage, we will notify active clients directly.
            </Typography>
            <Typography variant="body1" paragraph>
              Continuing to use our website or services after updates go live
              will indicate acceptance of the revised policy. We advise
              reviewing this page periodically to stay informed about how your
              data is treated.
            </Typography>
          </Box>

          <Box sx={{ mb: 4 }}>
            <Typography
              variant="h6"
              component="h2"
              gutterBottom
              sx={{ fontWeight: "bold", color: "black" }}
            >
              11. Contacting Us
            </Typography>
            <Typography variant="body1" paragraph>
              For privacy-related concerns, questions about your rights, or to
              submit an access request, please contact our team directly:
            </Typography>
            <Typography variant="body1" paragraph>
              <strong> Riches Media Digital</strong>
              <br />
              <strong>Email:</strong> letstalk@richesmediadigital.com
              <br />
              <strong>Phone:</strong> +1 201 456 2171
              <br />
              <strong>Address:</strong>
              <br />
              USA: 301 NJ-17, Rutherford, NJ 07070, United States
            </Typography>
            <Typography variant="body1" paragraph>
              We handle all inquiries confidentially and in accordance with the
              standards outlined above.
            </Typography>
          </Box>
        </Container>
      </div>
      <div style={{ marginTop: "-100px" }} />

      <Footer />
    </div>
  );
};

export default PrivacyPolicy;
